import Vue from 'vue'
import VXETable from 'vxe-table'

import FilterContent from './FilterContent'
import FilterInput from './FilterInput'

Vue.component(FilterContent.name, FilterContent)
Vue.component(FilterInput.name, FilterInput)

// 创建一个支持列内容的筛选
VXETable.renderer.add('FilterContent', {
  // 不显示底部按钮，使用自定义的按钮
  isFooter: false,
  // 筛选模板
  renderFilter (h, renderOpts, params) {
    return [
      <filter-content key={ params.$columnIndex } params={ params }></filter-content>
    ]
  },
  // 重置数据方法
  filterResetMethod ({ options }) {
    options.forEach(option => {
      option.data = { vals: [], sVal: '' }
    })
  },
  // 筛选数据方法
  filterMethod ({ option, row, column }) {
    const { vals } = option.data
    const cellValue = row[column.property]
    return vals.includes(cellValue)
  }
})

// 创建一个支持列内容的筛选
VXETable.renderer.add('FilterInput', {
  // 不显示底部按钮，使用自定义的按钮
  isFooter: false,
  // 筛选模板
  renderFilter (h, renderOpts, params) {
    return [
      <filter-input key={ params.$columnIndex } params={ params }></filter-input>
  ]
  },
  // 重置数据方法
  filterResetMethod ({ options }) {
    options.forEach(option => {
      option.data = { vals: [], sVal: '' }
    })
  },
  // 筛选数据方法
  filterMethod ({ option, row, column }) {
    const { vals } = option.data
    const cellValue = row[column.property]
    return vals.includes(cellValue)
  }
})
